import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../shared/api.service';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { EditPageComponent } from './edit-page/edit-page.component';
import { ServerDataSource, LocalDataSource } from 'ng2-smart-table';
import { Router } from '@angular/router';
import { Page } from '../../shared/data/page';
import { plainToClass } from 'class-transformer';
import { PublishRenderComponent } from '../projet/publish-render.component';
import swal from 'sweetalert2';

@Component({
  selector: 'ngx-listpage',
  templateUrl: './listpage.component.html',
  styleUrls: ['./listpage.component.scss']
})
export class ListPageComponent implements OnInit {


  constructor(private dialogService: NbDialogService,private apiService:ApiService, private sendeurService:EventSendeurService, private router:Router, private toastr:NbToastrService) { }

  ngOnInit() {
    this.getPage();
    this.sendeurService.pageSendeur.subscribe(data =>{
      this.getPage();
    })
  }

 

  source: LocalDataSource =  new LocalDataSource();
  settings = {

    // hideSubHeader: true,
    mode: 'external',
    actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave:false
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
  columns: {
    id: {
      title: 'ID',
      type: 'number',
      filter: false,
    },
    /* slug: {
      title: 'Slug',
      type: 'string',
    }, */
    urltmbPhoto: {
      title: 'Photo',
      type: 'html',
      valuePrepareFunction: (photo:string) => { return `<img  src="${photo}" height="50px" width="50px" />`; },
      filter: false
    },
    short_title: {
      title: 'Titre',
      type: 'string',
    },
    titre: {
      title: 'long Titre',
      type: 'string',
    },
    titreparent: {
      title: 'Page Parent',
      type: 'string',
    },
    is_publish: {
      title: '',
      type: 'custom',
      renderComponent: PublishRenderComponent, // ne pas oublier de déclarer dans le module et d'ajouter dans l'entré entryComponents
      filter: false,
    },

   
  },
  pager : {
    perPage :10
  },
 
};



  

  select($event){
    this.dialogService.open(EditPageComponent,{context:{id:$event.data.id}});
  }

  onDelete(event){
    // this.dialogService.open(DeletePageComponent,{context:{id:$event.data.id}});
    const page = plainToClass( Page,  event.data as object);
    
    swal({
      title: 'Suppression page',
      text: 'Voulez - vous vraiment supprimer ' + page.titre + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deletePageProvider(page.id).subscribe(data =>{
          
          // console.log(data);
          this.source.remove(event.data);
         
        },(err) =>{
          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }
    
          if(err.error.code ===500){
          
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
         }
        })

      },
    }).then((result) => {

      if (result.value) {


        this.toastr.success("Supprimé(e)", page.titre);

      }

      // this.dialogIsNotShow = false;

    });


  
  }

  
  onCreate(event){

    this.dialogService.open(EditPageComponent,{context:{id:0}});
  }


  getPage(){

    this.apiService.getAllPageProvider().subscribe(data =>{

      this.source.load(  plainToClass( Page, data) );
      // this.pages = plainToClass( Page, data);
      this.source.setSort([{ field: 'id', direction: 'desc' }]);

    },(err) =>{

      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }
    
    })
  }

}
